// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiplicationFactorsLogWrapper__h8NV9 {
  position: relative;
}

.multiplicationFactorsLogTableWrapper__h8lfX {
  box-shadow: var(--basic-box-shadow);
}

.multiplicationFactorsLogHeader__xfmhl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--tables-primary-row-surface-default);
  padding: 15px 25px;
}

.multiplicationFactorsLogTitle__pXyYd {
  margin: unset;
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.multiplicationFactorsLogTable__6cetS {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: var(--tables-primary-row-surface-default);
}
.multiplicationFactorsLogTable__6cetS th {
  padding: 16px 25px;
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  border-bottom: 1px solid var(--tables-title-stroke);
  border-top: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: left;
}
.multiplicationFactorsLogTable__6cetS td {
  padding: 16px 25px;
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  white-space: normal;
}

.multiplicationFactorsLogBodyRow__dL0Ds:hover {
  background: var(--tables-primary-row-surface-hover);
}

.skeletonText__tn37q {
  height: 24px;
}

.hideLogsButtonWrapper__SZQs3 {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
}

.searchPanel__xec9v {
  width: 300px;
}
@media (max-width: 1024px) {
  .searchPanel__xec9v {
    max-width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/MultiplicationFactors/components/MultiplicationFactorsLog/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,mCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qDAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,qDAAA;AAzEF;AA2EE;EACE,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mDAAA;EACA,gDAAA;EACA,uCAAA;EACA,gBAAA;AAzEJ;AA4EE;EACE,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yDAAA;EACA,mBAAA;AA1EJ;;AA+EE;EACE,mDAAA;AA5EJ;;AAgFA;EACE,YAAA;AA7EF;;AAgFA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AA7EF;;AAgFA;EACE,YAAA;AA7EF;AA+EE;EAHF;IAII,gBAAA;EA5EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.multiplicationFactorsLogWrapper {\n  position: relative;\n}\n\n.multiplicationFactorsLogTableWrapper {\n  box-shadow: var(--basic-box-shadow);\n}\n\n.multiplicationFactorsLogHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--tables-primary-row-surface-default);\n  padding: 15px 25px;\n}\n\n.multiplicationFactorsLogTitle {\n  margin: unset;\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.multiplicationFactorsLogTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: var(--tables-primary-row-surface-default);\n\n  th {\n    padding: 16px 25px;\n    color: var(--tables-title-text);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    border-top: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: left;\n  }\n\n  td {\n    padding: 16px 25px;\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    white-space: normal;\n  }\n}\n\n.multiplicationFactorsLogBodyRow {\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.skeletonText {\n  height: 24px;\n}\n\n.hideLogsButtonWrapper {\n  width: 100%;\n  display: flex;\n  margin-bottom: 10px;\n  justify-content: flex-end;\n}\n\n.searchPanel {\n  width: 300px;\n\n  @media (max-width: 1024px) {\n    max-width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiplicationFactorsLogWrapper": `multiplicationFactorsLogWrapper__h8NV9`,
	"multiplicationFactorsLogTableWrapper": `multiplicationFactorsLogTableWrapper__h8lfX`,
	"multiplicationFactorsLogHeader": `multiplicationFactorsLogHeader__xfmhl`,
	"multiplicationFactorsLogTitle": `multiplicationFactorsLogTitle__pXyYd`,
	"multiplicationFactorsLogTable": `multiplicationFactorsLogTable__6cetS`,
	"multiplicationFactorsLogBodyRow": `multiplicationFactorsLogBodyRow__dL0Ds`,
	"skeletonText": `skeletonText__tn37q`,
	"hideLogsButtonWrapper": `hideLogsButtonWrapper__SZQs3`,
	"searchPanel": `searchPanel__xec9v`
};
module.exports = ___CSS_LOADER_EXPORT___;
